<template>
  <el-dialog class="failed_chain" append-to-body :close-on-click-modal="false" :visible.sync="show" width="700px">
    <p slot="title" class="dialog_title">连锁店导入失败结果</p>
    <el-button type="primary" size="small" class="export_btn" icon="iconfont icon-download-template"
      @click="exportResult">导出结果</el-button>
    <el-table ref="failTable" border stripe size="mini" height="400" :data="chains">
      <el-table-column prop="chainName" label="连锁店名称" align="center"></el-table-column>
      <el-table-column prop="location" label="地址" align="center"></el-table-column>
    </el-table>
    <div class="i_footer" slot="footer">
      <el-button type="primary" size="small" class="btn confirm_btn" @click="show = false">确定</el-button>
      <el-button size="small" class="btn close_btn" @click="show = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { utils as xlsUtil, writeFileXLSX } from 'xlsx'
import { getChineseCharacters } from '@/utils/functions'


export default {
  name: 'FailedChain',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    chains: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(nv) {
        this.$emit('update:visible', nv)
      }
    }
  },
  methods: {
    setRowStyle(sheet) {
      const border = {
        top: { style: 'thin', color: 'FF7F7F7F' },
        bottom: { style: 'thin', color: 'FF7F7F7F' },
        left: { style: 'hair', color: 'FF7F7F7F' },
        right: { style: 'thin', color: 'FF7F7F7F' }
      }
      const style = {
        border,
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true // 内容是否换行展示
        },
        font: {
          sz: 12,
          name: '宋体'
        },
        fill: {
          fgColor: { rgb: 'FF0187FA' }
        }
      }
      for (let k in sheet) {
        if (sheet[k].constructor === Object) {
          sheet[k]['s'] = style
        }
      }
    },
    async exportResult() {
      const rows = this.chains.map(r => ({
        chainName: r.chainName,
        location: r.location
      }))
      const wb = xlsUtil.book_new()
      const wsheet = xlsUtil.json_to_sheet(rows)
      xlsUtil.book_append_sheet(wb, wsheet, '连锁店')

      // 更改列标题(即覆写第一行的数据)  orign: 用于操作的左上角单元格, 'A1' <=> { c: 0, r: 0 }
      xlsUtil.sheet_add_aoa(wsheet, [['连锁店名称', '地址']], { origin: 'A1' })

      // 设置行高
      // wsheet["!rows"] = [{ hpx: 22 }, { hpx: 22 }]

      // 计算最大列宽
      const nameMax = rows.reduce((w, r) => {
        const ccs = getChineseCharacters(r.chainName) // 提取中文字符
        const other = r.chainName.length - ccs.length
        return Math.max(w, ccs.length * 2.3 + other) // 列宽=中文字符*2.3+其他字符
      }, 10)
      const addrMax = rows.reduce((w, r) => {
        const ccs = getChineseCharacters(r.location)
        const other = r.location.length - ccs.length
        return Math.max(w, ccs.length * 2.3 + other)
      }, 20)
      // 设置列宽
      wsheet['!cols'] = [{ wch: Math.ceil(nameMax) }, { wch: Math.ceil(addrMax) }]
      // this.setRowStyle(wsheet)

      // 工作簿数据写入xlsx文件并下载
      writeFileXLSX(wb, '连锁店导入失败结果.xlsx', { compression: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.failed_chain {
  ::v-deep .el-dialog__header {
    padding: 12px 10px;
    box-shadow: 0 1px 0 0 #e9e9e9;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 16px;
  }

  ::v-deep .el-dialog__footer {
    box-shadow: 0 -1px 0 0 #e9e9e9;
    padding: 20px;
  }

  .export_btn {
    width: 110px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
    margin-bottom: 10px;

    .icon-download-template {
      font-size: 15px;
      margin-right: 5px;
    }
  }
}

.dialog_title {
  text-align: center;
  color: #282729;
  font-size: 18px;
  line-height: 25px;
}

.i_footer {
  text-align: center;

  .btn {
    width: 100px;
  }

  .confirm_btn {
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
    margin-right: 10px;
  }

  .close_btn:hover {
    color: #FF3973;
    background-color: rgba(#FF3973, .1);
    border-color: #FF3973;
  }
}
</style>
